export default __webpack_public_path__ + "static/media/006-elephant.280c7f5e.svg";